/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import { Redirect, type RouteContext } from '@atlassian/react-resource-router';
// eslint-disable-next-line jira/restricted/unsafe-global-state-stores
import { useJiraServiceManagementProjectNavigation } from '@jira/navigation-apps__sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';

export const SERVICE_DESK_PRODUCT = 'servicedesk';

export const defaultRedirectForSettings =
	(product: string) =>
	({ match }: RouteContext): React.JSX.Element | null => {
		const { data, loading } = useJiraServiceManagementProjectNavigation();

		// Wait for nav data to be available before deciding where to redirect on cold loads
		if (loading || !data) {
			return null;
		}

		if (
			data?.permissionInfo?.isAdmin ||
			data?.permissionInfo?.isSiteAdmin ||
			data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS
		) {
			return (
				<Redirect
					to={`/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`}
				/>
			);
		}

		if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) {
			return (
				<Redirect
					to={`/plugins/servlet/project-config/${String(match.params.projectKey)}/administer-versions`}
				/>
			);
		}

		return (
			<Redirect
				to={`/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`}
			/>
		);
	};
